module.exports = __webpack_public_path__ + "./img/cross.c634e607e1072dcd8eeb666a27095da8.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/cross.png
// module id = ./assets/images/cross.png
// module chunks = 0